import React from "react";
import { FaChevronLeft, FaPencilAlt, FaSave, FaTimes } from "react-icons/fa";
import { useHistory } from "react-router";
import styles from "./NavBar.module.scss";

interface Props {
  isEditingTags: boolean;
  editDisabled: boolean;
  batchEditDisabled: boolean;
  saveDisabled: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onBatchEdit: () => void;
}

const NavBar = ({
  isEditingTags,
  editDisabled,
  batchEditDisabled,
  saveDisabled,
  onEdit,
  onSave,
  onCancel,
  onBatchEdit,
}: Props) => {
  const history = useHistory();
  return (
    <div className={styles.navbar}>
      <div className={styles.group}>
        <button
          className={styles["light-button"]}
          onClick={() => history.goBack()}
        >
          <FaChevronLeft />
          &nbsp;返回
        </button>
      </div>
      <div className={styles.group}>
        {!isEditingTags ? (
          <button
            className={styles["light-button"]}
            onClick={onEdit}
            disabled={editDisabled}
          >
            <FaPencilAlt />
            &nbsp;编辑标签
          </button>
        ) : (
          <>
            <button
              className={styles["light-button"]}
              onClick={onBatchEdit}
              disabled={batchEditDisabled}
            >
              <FaPencilAlt />
              &nbsp;批量修改
            </button>
            <button
              className={styles["light-button"]}
              onClick={onSave}
              disabled={saveDisabled}
            >
              <FaSave />
              &nbsp;保存标签
            </button>
            <button className={styles["light-button"]} onClick={onCancel}>
              <FaTimes />
              &nbsp;放弃修改
            </button>
          </>
        )}
        {/* <batch-edit-tag-modal
            v-if="isBatchEditTagModalOpen"
            // @close="isBatchEditTagModalOpen = false"
            // :users="selectedUsers"
          /> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default NavBar;
